import {Sprite} from 'pixi.js';
import {Button, DeviceType} from '@gongxigames/framework/core';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {KeypadView} from '@gongxigames/framework/slot/modules/keypad';
import {ISpinButtonView, SpinButtonViewEvents} from '@gongxigames/framework/slot/modules/spinbutton';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {View} from '@gongxigames/framework/slot/fragments/module/view';

export class SpinButtonView extends View<GlobalEventsMapForBackwardCompatibility> implements ISpinButtonView {
    public static readonly NAME: symbol = Symbol('SpinButtonView');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.DESKTOP;

    protected _spinButton!: Button;

    public init(): void {
        this.initGraphicElements();
        this.setupEventsForButtons();
    }

    protected initGraphicElements(): void {
        this._spinButton = this.mainSprite.getChildByName<Button>('spinButton');
    }

    public initAutoplay(): void {
        this._spinButton.visible = false;
    }

    public uninitAutoplay(): void {
        this._spinButton.visible = true;
    }

    public enableSpinButton(): void {
        this._spinButton.enable();
    }

    public disableSpinButton(): void {
        this._spinButton.disable();
    }

    public spinButtonClickAction(): void {
    }

    public onSpinStarted(): void {
    }

    protected setupEventsForButtons(): void {
        this._spinButton.callback = this.onSpinButtonClicked.bind(this);
    }

    protected onSpinButtonClicked(): void {
        this.soundPlayer.play('spinclick');
        this.emit(SpinButtonViewEvents.SPIN_BUTTON_CLICKED);
    }

    public initFreeSpins(): void {
    }

    public initMainGame(): void {
    }

    public getViewDependencies(): (symbol|string)[] {
        return [...super.getViewDependencies(), KeypadView.NAME];
    }

    public isSpinButtonEnabled(): boolean {
        return this._spinButton.enabled;
    }

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadView.NAME).mainSprite;
    }
}
